// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t3dW_1D9gVEPGxSfha9y{align-self:stretch;align-items:flex-start;gap:4px;width:100%;display:flex}.ZzJhguxwf6cliIvgVeD8{width:64px}.ks3b27P0K8LpP4FZievq{margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `t3dW_1D9gVEPGxSfha9y`,
	"input": `ZzJhguxwf6cliIvgVeD8`,
	"wrapIcon": `ks3b27P0K8LpP4FZievq`
};
export default ___CSS_LOADER_EXPORT___;
